import * as v from "valibot";

import { rpcContract } from "../rpc";

export const updateWorldRpcContract = rpcContract({
  name: "updateWorld",
  paramsSchema: v.object({
    id: v.string(),
    name: v.string(),
    description: v.optional(v.string()),
    thumbnailFileId: v.optional(v.union([v.string(), v.literal("")])),
    postIds: v.optional(v.array(v.string())),
  }),
  resultSchema: v.object({
    id: v.string(),
    name: v.string(),
    description: v.nullable(v.string()),
    thumbnailFileId: v.nullable(v.string()),
    mediaUrl: v.nullable(v.string()),
    mediaPositionX: v.nullable(v.number()),
    mediaPositionY: v.nullable(v.number()),
    status: v.union([v.literal("live"), v.literal("draft")]),
    createdAt: v.string(),
    updatedAt: v.string(),
  }),
});

export type UpdateWorldParams = v.InferOutput<(typeof updateWorldRpcContract)["paramsSchema"]>;
export type UpdateWorldResult = v.InferOutput<(typeof updateWorldRpcContract)["resultSchema"]>;
